import { render, staticRenderFns } from "./validation_code_page.vue?vue&type=template&id=5da44172&scoped=true"
import script from "./validation_code_page.vue?vue&type=script&lang=js"
export * from "./validation_code_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da44172",
  null
  
)

export default component.exports